import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dropdown, DropdownDivider, Icon } from 'semantic-ui-react'
import {
  MarketSelectorWrap,
  SelectorTrigger,
  MarketHeader,
  MarketCity,
  CountLabel,
} from './MarketSelector.styled.js'

export function MarketSelectorView({
  isLoading,
  isOpen,
  isDirty,
  localSelectedMarkets,
  displayLabel,
  marketsDisplay,
  handleOpen,
  handleClose,
  selectAll,
  selectMarket,
  deselectMarket,
  toggleMarket,
  applySelectedMarkets,
}) {
  return (
    <MarketSelectorWrap
      as={Dropdown}
      id='market-selector'
      className='market-selector custom-dropdown'
      data-testid='navbar-market-select'
      loading={isLoading}
      search
      open={isOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      trigger={
        <SelectorTrigger>
          MARKET:{' '}
          <strong>
            {displayLabel.name}{' '}
            {displayLabel.count > 1 && (
              <CountLabel size='small' className={isDirty ? 'yellow' : 'green'}>
                +{displayLabel.count - 1}
              </CountLabel>
            )}
          </strong>
        </SelectorTrigger>
      }
    >
      <Dropdown.Menu>
        {marketsDisplay.map((m) => {
          const selected = localSelectedMarkets.includes(m.uid)
          return (
            <Dropdown.Item
              selected={selected}
              key={m.uid}
              data-testid={`navbar-market-item-${m.uid}`}
              onClick={() => {
                if (m.header) {
                  toggleMarket(m.uid)
                } else if (selected) {
                  deselectMarket(m.uid)
                } else {
                  selectMarket(m.uid)
                }
              }}
            >
              {m.header ? (
                <MarketHeader>
                  <span>{m.name}</span>
                  {selected && <Icon color='green' name='check' />}
                </MarketHeader>
              ) : (
                <MarketCity>
                  <span>{m.name}</span>
                  {selected && <Icon color='green' name='check' />}
                </MarketCity>
              )}
            </Dropdown.Item>
          )
        })}
        <DropdownDivider />
        <Dropdown.Item
          selected={localSelectedMarkets.length === 0}
          onClick={selectAll}
        >
          <MarketCity>
            <span>
              <strong>All Markets</strong>
            </span>
            <span>
              {localSelectedMarkets.length === 0 && (
                <Icon color='green' name='check' />
              )}
            </span>
          </MarketCity>
        </Dropdown.Item>
        <Dropdown.Item style={{ padding: 0, cursor: 'default' }}>
          <div style={{ padding: '8px' }}>
            <Button
              id='apply-market-btn'
              disabled={!isDirty}
              onClick={applySelectedMarkets}
              data-testid='navbar-market-apply-btn'
              style={{
                width: '100%',
                fontWeight: 'bold',
                opacity: isDirty ? '1 !important' : '0.6',
              }}
              color='green'
            >
              Apply
            </Button>
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </MarketSelectorWrap>
  )
}

MarketSelectorView.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  localSelectedMarkets: PropTypes.array.isRequired,
  displayLabel: PropTypes.shape({
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
  }).isRequired,
  marketsDisplay: PropTypes.array.isRequired,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  selectMarket: PropTypes.func.isRequired,
  deselectMarket: PropTypes.func.isRequired,
  toggleMarket: PropTypes.func.isRequired,
  applySelectedMarkets: PropTypes.func.isRequired,
}
